import { Routes, Route } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import IdleHandler from "./util/IdleHandler"
import { RouteGuard } from './components/RouteGuard';
import { PageLayout } from './components/PageLayout';

import { Home } from "./pages/Home";
import { Login } from "./pages/Login";
import { msalInstance, appRoles } from './util/authUtil';
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { Profile } from './pages/Profile';
import { CompanyInfo } from './pages/CompanyInfo';
import { Report } from './pages/Report';
import { Reports } from './pages/Reports';
import { useState } from 'react';
import { Error } from './pages/Error';
import { Error404 } from './pages/Error404';
import { ReportsAdmin } from './pages/ReportsAdmin';
import { ReportAdmin } from './pages/ReportAdmin';
import { ReportAdminCompany } from './pages/ReportAdminCompany';
import { Bookkeeping } from './pages/Bookkeeping';
import ErrorBoundary from './util/ErrorBoundary';
import { Users } from './pages/Users';
import { User } from './pages/User';
import { Companies } from './pages/Companies';
import { Company } from './pages/Company';

import  { routes } from './util/routes'
import { PrivacyStatement } from './pages/PrivacyStatement';
import { BookkeepingReport } from './pages/BookkeepingReport';
import { ReportAdminStatus } from './components/ReportAdminStatus';
import { ReportAdminSerty } from './components/ReportAdminSerty';
import { ReportAdminCompanies } from './components/ReportAdminCompanies';
import { ReportAdminOngoing } from './components/ReportAdminOngoing';
import { Settings } from './pages/Settings';
import { Messages } from './pages/Messages';
import { ToastNotifications } from './components/ToastNotifications';
import { MailTemplates } from './components/MailTemplates';
import { InfoTexts } from './components/InfoTexts'
import { Languages } from './pages/Languages';
import { Categories } from './pages/Categories';
import { ReportedPom } from './pages/ReportedPom';

library.add(fas);

interface IPagesProps {
  userLoaded: boolean;
}


const Pages = (props: IPagesProps) => {

  return (
    <Routes>
      <Route
        path={routes.ReportsAdmin.path}
        element={
          <RouteGuard roles={[appRoles.Admin]}>
            <ErrorBoundary fallback={<p>Something went wrong</p>}>
              <ReportsAdmin />
            </ErrorBoundary>
          </RouteGuard>
        }
      >
        <Route index element={<ReportAdminStatus />} />
        <Route
          path={routes.ReportAdminStatus.path}
          element={<ReportAdminStatus />}
        />
        <Route
          path={routes.ReportAdminSerty.path}
          element={<ReportAdminSerty />}
        />
        <Route
          path={routes.ReportAdminCompanies.path}
          element={<ReportAdminCompanies />}
        />
        <Route
          path={routes.ReportAdminOngoing.path}
          element={<ReportAdminOngoing />}
        />
      </Route>
      <Route
        path={routes.ReportAdmin.path}
        element={
          <RouteGuard roles={[appRoles.Admin]}>
            <ReportAdmin />
          </RouteGuard>
        }
      />
      <Route
        path={routes.ReportAdminCompany.path}
        element={
          <RouteGuard roles={[appRoles.Admin]}>
            <ErrorBoundary fallback={<p>Something went wrong</p>}>
              <ReportAdminCompany />
            </ErrorBoundary>
          </RouteGuard>
        }
      />
      <Route
        path={routes.ReportAdminReportedPom.path}
        element={
          <RouteGuard roles={[appRoles.Admin]}>
            <ErrorBoundary fallback={<p>Something went wrong</p>}>
              <ReportedPom />
            </ErrorBoundary>
          </RouteGuard>
        }
      />
      <Route
        path={routes.Users.path}
        element={
          <RouteGuard roles={[appRoles.Admin]}>
            <ErrorBoundary fallback={<p>Something went wrong</p>}>
              <Users />
            </ErrorBoundary>
          </RouteGuard>
        }
      />
      <Route
        path={routes.User.path}
        element={
          <RouteGuard roles={[appRoles.Admin]}>
            <ErrorBoundary fallback={<p>Something went wrong</p>}>
              <User />
            </ErrorBoundary>
          </RouteGuard>
        }
      />
      <Route 
        path={routes.Companies.path}
        element={
          <RouteGuard roles={[appRoles.Admin]}>
            <ErrorBoundary fallback={<p>Something went wrong</p>}>
              <Companies />
            </ErrorBoundary>
          </RouteGuard>
        }
      />
      <Route
        path={routes.Company.path}
        element={
          <RouteGuard roles={[appRoles.Admin]}>
            <ErrorBoundary fallback={<p>Something went wrong</p>}>
              <Company />
            </ErrorBoundary>
          </RouteGuard>
        }
      />
      <Route 
        path={routes.Bookkeeping.path}
        element={
          <RouteGuard roles={[appRoles.Admin]}>
            <ErrorBoundary fallback={<p>Something went wrong</p>}>
              <Bookkeeping />
            </ErrorBoundary>
          </RouteGuard>
        }
      />
      <Route
        path={routes.BookkeepingReport.path}
        element={
          <RouteGuard roles={[appRoles.Admin]}>
            <BookkeepingReport />
            </RouteGuard>
        }
      />
      <Route 
        path={routes.Categories.path}
        element={
          <RouteGuard roles={[appRoles.Admin]}>
            <ErrorBoundary fallback={<p>Something went wrong</p>}>
              <Categories />
            </ErrorBoundary>
          </RouteGuard>
        }
      />
      <Route 
        path={routes.Messages.path}
        element={
          <RouteGuard roles={[appRoles.Admin]}>
            <Messages />
          </RouteGuard>
        }
      />
      <Route 
        path={routes.Languages.path}
        element={
          <RouteGuard roles={[appRoles.Admin]}>
            <ErrorBoundary fallback={<p>Something went wrong</p>}>
              <Languages />
            </ErrorBoundary>
          </RouteGuard>
        }
      >
        <Route index element={<MailTemplates />} />
        <Route
          path={routes.MailTemplates.path}
          element={<MailTemplates />}
        />
        <Route
          path={routes.Infos.path}
          element={<InfoTexts />}
        />
      </Route>
      <Route 
        path={routes.Settings.path}
        element={
          <RouteGuard roles={[appRoles.Admin]}>
            <Settings />
          </RouteGuard>
        }
      />
      <Route
        path={routes.Profile.path}
        element={
          <RouteGuard roles={[appRoles.Admin, appRoles.GuestReporter, appRoles.SertyReporter]}>
          <ErrorBoundary fallback={<p>Something went wrong</p>}>
            <Profile />
          </ErrorBoundary>
          </RouteGuard>
      } />
      <Route
        path={routes.CompanyInfo.path}
        element={
          <RouteGuard roles={[appRoles.Admin, appRoles.GuestReporter, appRoles.SertyReporter]}>
            <ErrorBoundary fallback={<p>Something went wrong</p>}>
              <CompanyInfo />
            </ErrorBoundary>
          </RouteGuard>
      } />
      <Route
        path={routes.Reports.path}
        element={
          <RouteGuard roles={[appRoles.GuestReporter]}>
            <ErrorBoundary fallback={<p>Something went wrong</p>}>
              <Reports />
            </ErrorBoundary>
          </RouteGuard>
      } />
      <Route
        path={routes.Report.path}
        element={
          <RouteGuard roles={[appRoles.GuestReporter]}>
            <ErrorBoundary fallback={<p>Something went wrong</p>}>
              <Report />
            </ErrorBoundary>
          </RouteGuard>
      } />
      <Route
        path={routes.Home.path} element={
          <RouteGuard roles={[appRoles.Admin, appRoles.GuestReporter, appRoles.SertyReporter]}>
            <Home userLoaded={props.userLoaded} />
          </RouteGuard>
        } />
      <Route
        path={routes.PrivacyStatement.path} element={
          <RouteGuard roles={[appRoles.Admin, appRoles.GuestReporter, appRoles.SertyReporter]}>
            <PrivacyStatement />
          </RouteGuard>
        } />
      <Route path={routes.Login.path} element={<Login />} />
      <Route path={routes.Error.path} element={<Error />} />
      <Route path="*" element={<Error404 />} />
    </Routes>
  );
};

const App = () => {
  const [isUserLoaded, setIsUserLoaded] = useState(false);
    return (
        <MsalProvider instance={msalInstance}>
            <IdleHandler>
            <PageLayout onUserLoad={() => setIsUserLoaded(true)} userLoaded={isUserLoaded}>
                <Pages userLoaded={isUserLoaded} />
            </PageLayout>
            </IdleHandler>
            <ToastNotifications/>
        </MsalProvider>
    );
};

export default App;
